import React from "react";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import "./Modal.css";

export default ({ plot, showModal, closeModal }) => {
  return (
    <>
      <Modal
        show={showModal}
        dialogClassName="modal-dialog modal-dialog-centered modal-sm"
        contentClassName={"modal-content customPopup congrats"}
        style={{ paddingLeft: 0 }}
      >
        <button
          type="button"
          className="close"
          onClick={() => closeModal(false)}
          aria-label="Close"
        ></button>

        <div className="content">
          <div className="modal-caption text-center">
            <h2 className="title title-sm fw--700">Congratulations!</h2>
            <p className="muteClr">
              Your transaction is successfully completed!
            </p>

            <div className="horizontalCard">
              <img
                src={
                  plot?.plot_id
                    ? process.env.REACT_APP_INVENTORY_IMAGES +
                      `${plot?.size}/${plot?.rarity}.jpg`
                    : plot?.id
                    ? process.env.REACT_APP_INVENTORY_IMAGES +
                      "empyrean_tower.jpg"
                    : ""
                }
                alt={plot?.image}
                className="cardImg image-fit-contain"
              />
              {/* <div className="loadingImg">
                    <img src={ventorImg} alt="" className="loadImg" />
                    <p>Plot Deed will be shown here!</p>
                  </div> */}
            </div>
          </div>
          <button
            className="custom-btn accent-bg lg w-100"
            onClick={() => {
              closeModal(true);
            }}
          >
            View Details
          </button>

          <div className="mobile-btn">
            <button
              onClick={() => {
                closeModal(false);
              }}
              className="custom-btn gray-bg lg"
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
